import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseRoute } from '~/constants/routes'

import styles from './PaymentRequestSentSuccessScreen.module.scss'

export interface PaymentRequestSentSuccessScreenProps {
  /** When omitted (e.g. mock send), navigates to the communications inbox. */
  conversationId?: string
  recipientDisplay: string
}

export const PaymentRequestSentSuccessScreen = ({
  conversationId,
  recipientDisplay,
}: PaymentRequestSentSuccessScreenProps) => {
  const { t } = useTranslation(['Common', 'Dialogs'])
  const navigate = useNavigate()

  const handleViewConversation = () => {
    if (conversationId) {
      navigate(`${BaseRoute.COMMUNICATIONS}/${conversationId}`)
      return
    }
    navigate(BaseRoute.COMMUNICATIONS)
  }

  return (
    <div className={styles.successScreen}>
      <div className={styles.recipientRow}>
        <span className={styles.recipientText}>{recipientDisplay}</span>
        <button
          className={styles.viewConversationLink}
          type="button"
          onClick={handleViewConversation}
        >
          {t('Common:VIEW_CONVERSATION')}
        </button>
      </div>
    </div>
  )
}
